import { Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { InfoTip } from './InfoTip';

/** `info` adds an explanation bubble beside the label (provider and admin portals only). */
export function StatCard({ label, value, hint, icon, info }: { label: string; value: ReactNode; hint?: ReactNode; icon?: ReactNode; info?: ReactNode }) {
  return (
    <Card sx={{ height: '100%' }}>
      <CardContent>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center', color: 'text.secondary', mb: 0.5 }}>
          {icon}
          <Typography variant="body2">{label}</Typography>
          {info && <InfoTip title={info} label={`About ${label}`} />}
        </Stack>
        <Typography variant="h4" component="p" sx={{ fontVariantNumeric: 'tabular-nums' }}>
          {value}
        </Typography>
        {hint && (
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            {hint}
          </Typography>
        )}
      </CardContent>
    </Card>
  );
}
